/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReferralPolicy
 */
export interface ReferralPolicy {
    /**
     * The SendGrid template the invite is sent with. Configured per campaign when the objective is assigned; Required — an objective with no template refuses the claim.
     * @type {string}
     * @memberof ReferralPolicy
     */
    inviteEmailTemplateId?: string;
    /**
     * Sender name on the invite. Absent uses the inviter's own supplied name.
     * @type {string}
     * @memberof ReferralPolicy
     */
    inviteFromName?: string;
    /**
     * Cap on credited invites per member per period. Absent is uncapped.
     * @type {number}
     * @memberof ReferralPolicy
     */
    maxInvitesPerPeriod?: number;
}

/**
 * Check if a given object implements the ReferralPolicy interface.
 */
export function instanceOfReferralPolicy(value: object): value is ReferralPolicy {
    return true;
}

export function ReferralPolicyFromJSON(json: any): ReferralPolicy {
    return ReferralPolicyFromJSONTyped(json, false);
}

export function ReferralPolicyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReferralPolicy {
    if (json == null) {
        return json;
    }
    return {
        
        'inviteEmailTemplateId': json['inviteEmailTemplateId'] == null ? undefined : json['inviteEmailTemplateId'],
        'inviteFromName': json['inviteFromName'] == null ? undefined : json['inviteFromName'],
        'maxInvitesPerPeriod': json['maxInvitesPerPeriod'] == null ? undefined : json['maxInvitesPerPeriod'],
    };
}

export function ReferralPolicyToJSON(json: any): ReferralPolicy {
    return ReferralPolicyToJSONTyped(json, false);
}

export function ReferralPolicyToJSONTyped(value?: ReferralPolicy | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'inviteEmailTemplateId': value['inviteEmailTemplateId'],
        'inviteFromName': value['inviteFromName'],
        'maxInvitesPerPeriod': value['maxInvitesPerPeriod'],
    };
}

